import {Injectable} from '@angular/core';
import {BasicService} from '../../utils/basic.service';
import {Asset, AssetTypes} from '../../models/base/Asset';
import {DataService} from '../util/data.service';
import {HttpClient} from '@angular/common/http';
import {UtilsService} from '../util/utils.service';
import * as ROUTES from '../../utils/ROUTES';
import {GenericResponse} from '../../models/util/GenericResponse';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class AssetService extends BasicService<Asset>{

  public static readonly MAIN_BACKGROUND_IMAGE_KEY = 'assets.public.main_background_image';
  public static readonly LOGO_KEY = 'assets.public.logo';
  public static readonly LOGIN_HEADLINE_PREFIX_TEXT = 'assets.public.login_headline_prefix';
  public static readonly LOGIN_HEADLINE_TEXT = 'assets.public.login_headline';
  public static readonly PAGE_TITLE = 'assets.public.page_title';
  public static readonly PAGE_FAVICON = 'assets.public.page_favicon';
  public static readonly URL_IMPPRINT_KEY = 'assets.public.imprint_link';
  public static readonly URL_POLICIES_KEY = 'assets.public.gdpr_link';

  public publicAssets: Map<string, Asset> = new Map<string, Asset>();

  constructor(
    private dataService: DataService,
    private http: HttpClient,
    private utils: UtilsService,
    private translate: TranslateService
  ) {
    super(dataService, http, ROUTES.ASSET_ROUTE);
  }

  public async getPublicAssetByKey(key: string): Promise<Asset> {
    if(this.publicAssets.has(key)){
      return this.publicAssets.get(key);
    }
    let response: Asset = undefined;
    await this.http.get<GenericResponse<Asset>>(`${ROUTES.ASSET_ROUTE_PUBLIC}/${key}`, this.dataService.getHttpOptions()).toPromise()
      .then((res: GenericResponse<Asset>) => {
        if(res?.status == 200){
          response = res.body;
        }
      });
    if(response != undefined){
      this.publicAssets.set(response.id, response);
    }
    return response;
  }

  public getTypesForTableFilter(): {value: string, title: string}[] {
    const types = AssetTypes;
    const response: {value: string, title: string}[] = [];
    for(const t of Object.keys(types)){
      const type = types[t];
      response.push({title: type.name, value: type.key});
    }
    return response;
  }

  public getTranslatedValue(assetJson: string): string | undefined {
    try{
      const parsed = JSON.parse(assetJson);
      if(parsed[this.translate.currentLang]){
        return parsed[this.translate.currentLang];
      }
    }catch(error){
      console.debug(error);
    }
    return undefined;
  }
}
